export default __webpack_public_path__ + "static/media/Caregiver_new icon.6a7c90b8.svg";